<form [formGroup]="form">
  <table
    class="w-100 mb-3"
    mat-table
    [dataSource]="priorDataSource"
    formArrayName="priors"
  >
    <ng-container matColumnDef="modality">
      <th
        class="px-1 column-short"
        scope="col"
        mat-header-cell
        *matHeaderCellDef
      >
        <div class="">Modality</div>
      </th>
      <td
        class="px-1 align-top"
        mat-cell
        *matCellDef="let row; let priorIndex = index"
        [formGroupName]="priorIndex"
      >
        @if(row?.isEditing) {
        <mat-form-field
          class="inline-editable-editor prior-modality-field w-100"
        >
          <mat-select
            formControlName="modality"
            placeholder=""
            class="text-center"
          >
            <mat-option></mat-option>
            <mat-option
              *ngFor="let m of modalityList$ | async"
              value="{{ m }}"
              class="text-center"
            >
              {{ m }}
            </mat-option>
          </mat-select>
          <mat-error>
            @if(getPriorControls(priorIndex)?.modality.errors?.required) {
            Please select a Modality. }
          </mat-error>
        </mat-form-field>
        } @else {
        <div class="p-1">{{ row.modality }}</div>
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="dateOfStudy">
      <th
        class="px-1 column-medium"
        scope="col"
        mat-header-cell
        *matHeaderCellDef
      >
        <div class="">Date of Study</div>
      </th>
      <td
        class="align-top"
        mat-cell
        *matCellDef="let row; let priorIndex = index"
        [formGroupName]="priorIndex"
      >
        @if(row?.isEditing) {
        <mat-form-field class="inline-editable-editor w-100">
          <input
            matInput
            formControlName="studyDate"
            [matDatepicker]="priorDatePicker"
            [matDatepickerFilter]="dateFilter"
            placeholder="dd/mm/yyyy"
          />
          <mat-datepicker-toggle
            tabIndex="-1"
            matSuffix
            [for]="priorDatePicker"
          ></mat-datepicker-toggle>
          <mat-datepicker #priorDatePicker></mat-datepicker>
          <mat-error>
            @if(getPriorControls(priorIndex)?.studyDate.errors?.required &&
            !getPriorControls(priorIndex)?.studyDate.errors?.matDatepickerParse)
            { Prior Study Date is required. }
            @if(getPriorControls(priorIndex)?.studyDate.errors?.matDatepickerFilter)
            { Future date is not allowed. }
            @if(getPriorControls(priorIndex)?.studyDate.errors?.matDatepickerParse)
            { Invalid date format }
          </mat-error>
        </mat-form-field>
        } @else {
        <div class="px-1 lh-std">
          {{ formatStudyDate(row.studyDate) }}
        </div>
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="accessionNumber">
      <th class="px-1" scope="col" mat-header-cell *matHeaderCellDef>
        <div class="">Accession</div>
      </th>
      <td
        class="align-top"
        mat-cell
        *matCellDef="let row; let priorIndex = index"
        [formGroupName]="priorIndex"
      >
        @if(row?.isEditing) {
        <div class="px-1">
          <mat-form-field class="inline-editable-editor">
            <input
              type="text"
              class="w-100"
              matInput
              formControlName="accessionNumber"
              (keydown.enter)="savePriorRow(row, priorIndex)"
            />
            <mat-icon class="hide" matSuffix aria-hidden="true">edit</mat-icon>
            <mat-error>
              @if(getPriorControls(priorIndex)?.accessionNumber.errors?.maxlength)
              { Accession Number must be no more than 50 characters long. }
              @if(getPriorControls(priorIndex)?.accessionNumber.errors?.pattern)
              { Invalid characters in the field. }
            </mat-error>
          </mat-form-field>
        </div>
        } @else {
        <input
          class="hidden-input break-word w-100"
          value="{{ row.accessionNumber }}"
          disabled
        />
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="actions">
      <th
        class="px-1 column-medium"
        scope="col"
        mat-header-cell
        *matHeaderCellDef
      >
        <div class="">Actions</div>
      </th>
      <td
        class="align-top d-flex"
        mat-cell
        *matCellDef="let row; let priorIndex = index"
        [formGroupName]="priorIndex"
      >
        <div
          *ngIf="row?.isEditing || editable"
          class="d-flex align-items-center"
        >
          <button
            [attr.id]="
              PriorsComponent.getUploadButtonIdFromPriorId(row?.priorId)
            "
            class="mx-1 btn-prior"
            mat-icon-button
            [disabled]="isUploadButtonDisabled(row) || row?.isEditing"
            (click)="initiateFileUpload(fileUpload.click(), row)"
            matTooltip="Send report"
          >
            <mat-icon class="mat-primary send-icon" svgIcon="upload">
            </mat-icon>
            <span>{{ getUploadBtnText(row?.priorId) }}</span>
          </button>
          @if(row?.isEditing) {
          <button
            class="mx-1 btn-prior btn-save"
            mat-icon-button
            (click)="savePriorRow(row, priorIndex)"
            matTooltip="Save"
          >
            <mat-icon class="mat-primary" svgIcon="save"> </mat-icon>
          </button>
          } @else if(editable) {
          <button
            class="mx-1 btn-prior btn-edit"
            mat-icon-button
            (click)="editPriorRow(row, priorIndex)"
            matTooltip="Edit"
          >
            <mat-icon class="mat-primary" svgIcon="edit"> </mat-icon>
          </button>
          }
          <button
            class="mx-1 btn-prior btn-delete"
            mat-icon-button
            (click)="deletePriorRow(row, priorIndex)"
            matTooltip="Delete"
          >
            <mat-icon class="mat-primary" svgIcon="cancel"> </mat-icon>
          </button>
        </div>
      </td>
      <td mat-footer-cell *matFooterCellDef colspan="4" class="text-right">
        @if(editable) {
        <button
          mat-button
          mat-stroked-button
          class="mat-primary add-icon mr-1 btn-hallow"
          (click)="addNewPriorRow()"
          id="add-prior-button"
        >
          <mat-icon matSuffix class="mr-1">add_circle_outline</mat-icon>
          Add prior image/report
        </button>
        }
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="priorColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: priorColumns"></tr>
    <tr mat-footer-row *matFooterRowDef="['actions']"></tr>
  </table>
  <input
    type="file"
    class="file-input d-none"
    (change)="onFileSelected($event)"
    #fileUpload
    [accept]="PriorsComponent.acceptedFileExtensionsStr"
  />
</form>
